// Polyfills for older browsers (IE11, Edge Legacy)
import "core-js/stable";
import "regenerator-runtime/runtime";

import App from "./components/App";
import * as React from "react";
import { createRoot } from "react-dom/client";

const container = document.getElementById("container");
if (!container) {
  throw new Error("Container element not found");
}

const root = createRoot(container);

const render = (Component: React.ComponentType) => {
  root.render(<Component />);
};

/* Render application after Office initializes */
Office.onReady(() => {
  render(App);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
